/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import GlobalSettings from '@/model/global/GlobalSettings'
import { keyBy } from 'lodash-es'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    form: false,
    requiredNew: false,
    header: false
  }
}

const config = {

  load: async function (filter) {
    const notTouchableDish = keyBy((await hillo.get('Dishes.php?op=cantChangeDish')).content, 'code')
    const systemDish = ['cashWithdraw', 'cashDeposit', 'gel', 'gk', 'lk']
    return (await hillo.get('Dishes.php', {
      lang: GlobalSettings.getLang(),
      onlyActive: 0,
      ...filter
    }))
      .content
      .filter(it => !systemDish.includes(it.code))
      .filter(x => x.isPfandDish === '1')
      .map(function (item) {
        item.displayCode = item.code.length > 5 ? item.code.slice(0, 5) + '...' : item.code
        item.id = item.dishId
        item.attributeGroupId = [
          item.inheritAttributeGroupId ? item.inheritAttributeGroupId.split(',') : [],
          item.localAttributeGroupId ? item.localAttributeGroupId.split(',') : []
        ].flat().join(',')
        item.usingPfandDishIds = item.usingPfandDishIds.split(',')
        item.langs = item.langs.map(i => {
          return {
            ...i,
            desc: i.description
          }
        })
        item.editable = !notTouchableDish[item.code]
        item.priceDisplay = item.price
        return item
      })
  }

}
export default IKDataEntity.ModelFactory(entity, config)
